/* eslint-disable @typescript-eslint/no-explicit-any */
// ==============================
// Imports
// ==============================

// MUI Components
import AppBarSpacer from '../../components/common/AppBarSpacer';
import {
  Typography,
  Box,
  InputAdornment,
  TextField,
  List,
} from '@mui/material';
import PageHeader from '../../components/common/PageHeader';

// Libraries
import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';

// Local components
import MiniDrawer from '../../components/MiniDrawer';
import { apiGet } from '../../utils/apiClient';
import { ServiceType, Response } from '../../types/ServiceAccordion.type';
import CourseTypeCard from '../../components/Course/CourseTypeCard';
import { useTranslation } from '../../i18n';

const CourseSetting = () => {
  const { t } = useTranslation();
  // States
  const [open, setOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [services, setServices] = useState<ServiceType[]>([]);

  const fetchCourses = async () => {
    // Fetch service types from the API
    const res = await apiGet<Response<ServiceType>>(
      '/service/filter?name=COURSE',
    );

    setServices(res.data);
  };

  const handleSearchChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  // Hooks
  useEffect(() => {
    fetchCourses();
  }, []);

  // ==============================
  // Render
  // ==============================
  return (
    <>
      <div className="flex h-screen">
        {/* Sidebar */}
        <MiniDrawer open={open} setOpen={setOpen} />

        {/* Main content */}
        <main className="flex-1 overflow-auto app-page-bg">
          {/* Offset for fixed AppBar (height = 64px) */}
          <AppBarSpacer />

          <div className="h-full px-6 py-4">
            <PageHeader
              title={t('courseSettings.title')}
              subtitle={t('courseSettings.subtitle')}
            />

            <Box>
              <TextField
                fullWidth
                placeholder={t('courseSettings.searchPlaceholder')}
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ mb: 3, backgroundColor: 'background.paper' }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search size={20} />
                      </InputAdornment>
                    ),
                  },
                }}
              />

              <List sx={{ width: '100%', pt: 0 }}>
                {services.length === 0 ? (
                  <Typography
                    color="text.secondary"
                    variant="body1"
                    sx={{ textAlign: 'center', py: 4 }}
                  >
                    {searchTerm
                      ? 'No services match your search'
                      : 'No services available'}
                  </Typography>
                ) : (
                  services[0].subtypes.map((course) => (
                    <CourseTypeCard
                      key={course.id}
                      courseType={course}
                      fetchCourses={fetchCourses}
                    />
                  ))
                )}
              </List>
            </Box>
          </div>
        </main>
      </div>
    </>
  );
};

export default CourseSetting;
